<template>
  <bita-modal
    id="shipping-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.name"
            />
            <bita-input
              type="text"
              name="duration"
              label="مدت زمان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.duration"
            />
            <bita-uploader
              name="icon"
              label="تصویر"
              ref="uploader"
              rules="size:50"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.icon"
              :icon-url="formData.icon_url"
            />
            <bita-select-simple
              name="status"
              label="وضعیت"
              ref="statusDropDown"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="statuses"
              data-text-field="title"
              data-value-field="id"
              v-model="formData.status"
            />
          </div>
        </div>
      </bita-form>
      <div class="row mt-2 mb-2">
        <div class="col-lg-3">
          <bita-bootbutton
            v-if="formData.id"
            :title="shippingPriceButton.text"
            :type="shippingPriceButton.type"
            :icon="shippingPriceButton.icon"
            btn-width="200px"
            @click.native="addShippingPrice"
          />
        </div>
      </div>
      <hr />
      <bita-form v-if="addShippingPriceInput" ref="shippingpriceform">
        <div slot="body">
          <div class="row mt-3 mb-3">
            <bita-select-simple
              name="is_post_paid"
              label="شیوه محاسبه قیمت"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="shippingPricesData.is_post_paid"
              :data-source="[{id: 0, name: 'پیش کرایه'},{id: 1, name: 'پس کرایه'}]"
              data-text-field="name"
              data-value-field="id"
            />
            <bita-input
              type="text"
              name="from"
              label="از"
              subtitle="مبلغ سفارش"
              rules="required"
              :has-thousand-seprator="true"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="shippingPricesData.from"
            />
            <bita-input
              type="text"
              name="to"
              label="تا"
              rules="required"
              subtitle="مبلغ سفارش"
              :has-thousand-seprator="true"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="shippingPricesData.to"
            />
            <bita-input
              v-if="shippingPricesData.is_post_paid == 0"
              type="text"
              name="price"
              label="هزینه"
              rules="required"
              :has-thousand-seprator="true"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="shippingPricesData.price"
            />
          </div>
          <div class="row mt-3 mb-3">
            <bita-select-simple
              name="province_meta"
              label="برای استان های"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="metaLists"
              data-text-field="name"
              data-value-field="id"
              v-model="shippingPricesData.province_meta"
            />
            <bita-multiselect
              v-if="
                !shippingPricesData.province_meta ||
                  shippingPricesData.province_meta > 1
              "
              name="province_value"
              label="استان ها"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="provinces"
              data-text-field="name"
              data-value-field="id"
              autocomplete="false"
              v-model="shippingPricesData.province_value"
              @change="onChangeProvince"
            />
          </div>
          <div class="row mt-3 mb-3">
            <bita-select-simple
              name="city_meta"
              label="برای شهر های"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="metaLists"
              data-text-field="name"
              data-value-field="id"
              v-model="shippingPricesData.city_meta"
            />
            <bita-multiselect
              v-if="
                !shippingPricesData.city_meta ||
                  shippingPricesData.city_meta > 1
              "
              name="city_value"
              label="شهر ها"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="cities"
              data-text-field="name"
              data-value-field="id"
              autocomplete="false"
              v-model="shippingPricesData.city_value"
              @change="onChangeCity"
            />
          </div>
          <!-- <div
            class="row mt-3 mb-3"
            v-if="
              !shippingPricesData.province_meta ||
                (shippingPricesData.province_meta == 3 &&
                  shippingPricesData.city_meta == 3)
            "
          >
            <bita-select-simple
              name="district_meta"
              label="برای منطقه های"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="metaLists"
              data-text-field="name"
              data-value-field="id"
              v-model="shippingPricesData.district_meta"
            />
            <bita-multiselect
              v-if="
                !shippingPricesData.district_meta ||
                  shippingPricesData.district_meta > 1
              "
              name="district_value"
              label="منطقه ها"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="districts"
              data-text-field="name"
              data-value-field="id"
              autocomplete="false"
              v-model="shippingPricesData.district_value"
            />
          </div> -->
          <bita-bootbutton
            v-if="!shippingPricesData.id"
            type="primary mt-2 mb-2"
            title="ذخیره"
            icon="fas fa-save"
            btn-width="150px"
            @click.native="saveShippingPrice"
          />
          <bita-bootbutton
            v-if="shippingPricesData.id"
            type="primary mt-2 mb-2"
            title="به روزرسانی"
            icon="fas fa-save"
            btn-width="150px"
            @click.native="updateShippingPrice"
          />
        </div>
      </bita-form>
      <div class="row">
        <bita-grid
          v-show="formData.id"
          ref="modalgrid"
          :columns="gridColumns"
          :read-data="readData"
        />
      </div>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-if="formData.id"
        type="primary"
        title="به روزرسانی"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import { citiesApi, shippingApi } from "@/api/apiManagement";

export default {
  data() {
    return {
      colWidth: "col-lg-4",
      formData: {},
      shippingPricesGrid: {},
      shippingPricesData: {},
      addShippingPriceInput: false,
      statuses: [
        { id: 1, title: "فعال" },
        { id: 2, title: "غیر فعال" },
      ],
      shippingPriceButton: {
        text: "افزودن بازه قیمت جدید",
        type: "primary",
        icon: "fas fa-plus-square",
      },
      metaLists: [
        { id: 1, name: "همه" },
        { id: 2, name: "بجز" },
        { id: 3, name: "انتخابی" },
      ],
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        {
          title: "از",
          template: (e) => (e.from ? this.$thousandSeprator(e.from) : "-"),
        },
        {
          title: "تا",
          template: (e) => (e.to ? this.$thousandSeprator(e.to) : "-"),
        },
        {
          title: "هزینه ارسال",
          template: (e) => (e.price ? this.$thousandSeprator(e.price) : "-"),
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
      isLoadingModal: false,
      provinces: [],
      cities: [],
      // districts: [],
    };
  },
  computed: {
    title() {
      return this.formData.id ? `ویرایش ${this.formData.name}` : `افزودن`;
    },
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    init({ name, duration, icon_url, icon, status, text, id }, prices) {
      this.formData = { name, duration, icon_url, icon, status, text, id };
      this.shippingPricesGrid = prices;
      this.fetchProvinces();
      this.$showModal("#shipping-form");
      this.loadData();
    },
    fetchProvinces() {
      this.isLoadingModal = true;
      citiesApi
        .getProvinces()
        .then((res) => {
          this.provinces = res.data.entity;
        })
        .finally(() => (this.isLoadingModal = false));
    },
    onChangeProvince() {
      this.getCities();
      // this.getDistricts();
    },
    // onChangeCity() {
    //   this.getDistricts();
    // },
    getCities() {
      this.isLoadingModal = true;
      let filter = { province_id: this.shippingPricesData.province_value };
      if (this.shippingPricesData.province_meta == 2)
        filter.province_id = collect(this.provinces)
          .whereNotIn("id", this.shippingPricesData.province_value)
          .pluck("id");
      citiesApi
        .getAllCities(filter)
        .then((res) => {
          this.cities = res.data.entity;
        })
        .finally(() => (this.isLoadingModal = false));
    },
    // getDistricts() {
    //   this.isLoadingModal = true;
    //   let filter = {
    //     province_id:
    //       this.shippingPricesData.province_meta > 1
    //         ? this.shippingPricesData.province_value
    //         : null,
    //     city_id:
    //       this.shippingPricesData.city_meta > 1
    //         ? this.shippingPricesData.city_value
    //         : null,
    //   };
    //   if (this.shippingPricesData.province_meta == 2)
    //     filter.province_id = collect(this.provinces)
    //       .whereNotIn("id", this.shippingPricesData.province_value)
    //       .pluck("id");

    //   if (this.shippingPricesData.city_meta == 2)
    //     filter.city_id = collect(this.cities)
    //       .whereNotIn("id", this.shippingPricesData.city_value)
    //       .pluck("id");
    //   citiesApi
    //     .getDitricts(filter)
    //     .then((res) => {
    //       this.districts = res.data.entity;
    //     })
    //     .finally(() => (this.isLoadingModal = false));
    // },

    readData(e) {
      const _this = this;
      setTimeout(function() {
        if (_this.shippingPricesGrid.length > 0)
          e.success(_this.shippingPricesGrid);
        else e.success([]);
      }, 400);
    },
    loadData() {
      this.$refs.modalgrid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    addShippingPrice() {
      if (this.addShippingPriceInput) return this.addShippingPricebutton();
      return this.removeShippingPriceButton();
    },
    removeShippingPriceButton() {
      this.addShippingPriceInput = true;
      this.shippingPriceButton = {
        text: "حذف",
        type: "danger",
        icon: "fas fa-minus-square",
      };
      this.shippingPricesData = { from: 0, to: 0, price: 0 };
    },
    addShippingPricebutton() {
      this.addShippingPriceInput = false;
      this.shippingPriceButton = {
        text: "افزودن شیوه ارسال جدید",
        type: "primary",
        icon: "fas fa-plus-square",
      };
      this.shippingPricesData = {};
    },
    edit(e) {
      this.isLoadingModal = true;
      let row = this.$refs.modalgrid.getSelectedGridRow(e);
      const _this = this;
      shippingApi
        .getShippingPrice(row.id)
        .then((res) => {
          let shipping = res.data.entity.shipping_price;
          this.cities = res.data.entity.selects.cities;
          // this.districts = res.data.entity.selects.districts;
          this.addShippingPriceInput = true;
          setTimeout(() => {
            this.shippingPricesData = shipping;
            this.isLoadingModal = false;
          }, 3000);
        })
        .catch(() => (this.isLoadingModal = false));
    },
    delete(e) {
      let shippingPrices = this.$refs.modalgrid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف این مورد اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$emit("on-delete-shippingprice", shippingPrices);
        }
      });
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;
          shippingApi
            .createShippings(this.$getFormData(this.formData))
            .then((res) => {
              this.$emit("on-reload");
              this.reset();
              this.$hideModal("#shipping-form");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    update() {
      console.log(this.formData);
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;
          shippingApi
            .updateShippings(this.formData.id, this.$getFormData(this.formData))
            .then((res) => {
              this.$emit("on-reload");
              this.reset();
              this.$hideModal("#shipping-form");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    saveShippingPrice() {
      this.$refs.shippingpriceform.validate().then((result) => {
        if (result) {
          let data = {
            ...this.shippingPricesData,
            shipping_id: this.formData.id,
          };
          this.isLoadingModal = true;
          shippingApi
            .createShippingPrices(data.shipping_id, data)
            .then((res) => {
              this.loadData();
              this.$emit("on-reload");
              this.reset();
              this.$hideModal("#shipping-form");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    updateShippingPrice() {
      this.$refs.shippingpriceform.validate().then((result) => {
        if (result) {
          this.isLoadingModal = true;

          shippingApi
            .updateShippingPrices(
              this.shippingPricesData.shipping_id,
              this.shippingPricesData.id,
              this.shippingPricesData
            )
            .then((res) => {
              this.$izitoast("success", "موفق", res.data.message);
              this.loadData();
              this.$emit("on-reload");
              this.reset();
              this.$hideModal("#shipping-form");
            })
            .finally(() => (this.isLoadingModal = false));
        }
      });
    },
    reset() {
      this.formData = {};
      this.shippingPricesData = {};
      this.addShippingPriceInput = false;
      this.addShippingPricebutton();
      this.$refs.form.reset();
      this.$refs.uploader.reset();
    },
  },
};
</script>
